module.exports = __webpack_public_path__ + "img/4.34d8b8dc.png";